module.exports = __webpack_public_path__ + "img/vue2-corpsavant_rose.c18882ac.png";